import { X } from 'lucide-react';
import { ReactNode } from 'react';
import Modal from '.';
import Button from '../Button';

interface IProps {
  open: boolean;
  onHide: any;
  title: any;
  applyButton: any;
  applyColor?: string;
  onApply: any;
  children: ReactNode;
  dialogClassName?: string;
}

export const ModalButton = ({ icon, text }: { icon: ReactNode; text: string }) => {
  return (
    <>
      {icon}
      {text}
    </>
  );
};

const CommonModal = (props: IProps) => {
  const {
    open,
    onHide,
    title,
    applyButton,
    applyColor = 'bg-blue-600 hover:bg-blue-700',
    onApply,
    children,
    dialogClassName = '',
  } = props;

  return (
    <Modal
      show={open}
      onHide={onHide}
      modal-center="true"
      className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
      dialogClassName={`w-screen md:w-[40rem] bg-white shadow rounded-xl dark:bg-zinc-600 flex flex-col h-full ${dialogClassName}`}
    >
      <Modal.Header
        className="flex items-center justify-between p-4 border-b border-slate-300 dark:border-zinc-500 bg-blue-50 dark:bg-zink-700"
        closeButtonClass="transition-all duration-200 ease-linear text-slate-500 hover:text-red-500 dark:text-zinc-200 dark:hover:text-red-500"
      >
        <Modal.Title className="text-lg font-bold text-slate-800 flex items-center">
          {title}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
        {children}
      </Modal.Body>

      <Modal.Footer className="flex items-center justify-between p-4 mt-auto border-t border-slate-200 dark:border-zinc-500 bg-slate-50 dark:bg-zink-700">
        <Button color="white" type="button" onClick={onHide}>
          <X className="w-4 h-4 mr-2" /> Hủy bỏ
        </Button>
        <Button type="button" className={applyColor} onClick={onApply}>
          {applyButton}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CommonModal;
